<script setup lang="ts">
import H5Shell from './layouts/H5Shell.vue'
</script>

<template>
  <a class="skip-link" href="#main-content">跳到主内容</a>
  <H5Shell />
</template>
